import type { PresenceLocation } from '../../components/Presence/PresenceContract';

type EnvironmentPresenceSelection = {
	family: string | null;
	environmentId?: string | null;
	itemId?: string | null;
};

export function getEnvironmentPresenceLocation({ family, environmentId, itemId }: EnvironmentPresenceSelection): PresenceLocation | null {
	if (!family) {
		return environmentId ? { itemType: 'environment', itemId: environmentId } : null;
	}
	if (family === 'environment' && environmentId) {
		return { itemType: 'environment', itemId: environmentId };
	}
	return {
		itemType: family,
		itemId: itemId ? (environmentId ? `${environmentId}:${itemId}` : itemId) : environmentId ?? 'overview',
		relatedItemType: environmentId ? 'environment' : undefined,
		relatedItemId: environmentId ?? undefined,
	};
}
